import getSubdomain from './getSubdomain'

import { LanguagePreference } from 'models/LanguagePreference'
export const getDefaultLogoutURL = (lang:LanguagePreference, signout?: boolean) => {
  const langQueryParam = lang === 'es' ? '?lang=es-mx' : ''
  const langSubdomain = lang === 'es' ? 'es.' : ''
  const subdomain = getSubdomain(process.env.REACT_APP_MY_MEDICARE_ENV || '')

  const domainToIgnore = lang === 'es' ? 'www' : undefined
  const conditionalSubdomain = getSubdomain(process.env.REACT_APP_MY_MEDICARE_ENV || '', domainToIgnore)

  return `https://${subdomain}medicare.gov/sso/signout?redirect_uri=https://${langSubdomain}${conditionalSubdomain}medicare.gov/${signout ? 'mbp/signout.aspx' : ''}${langQueryParam}`
}

export const getDefaultLoginURL = (lang:LanguagePreference) => {
  const langQueryParam = lang === 'es' ? '?lang=es-mx' : ''
  const subdomain = getSubdomain(process.env.REACT_APP_MY_MEDICARE_ENV || '')

  return `https://${subdomain}medicare.gov/account/login${langQueryParam}`
}
